






































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";


export interface Data {
  teacher: any
  errors: any[]
  isShowPassword: boolean,
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      teacher: {
        login_id: "",
        password: "",
        password_confirmation: "",
        name: "",
        curriculum_id: "",
        curriculum_ids: [],
        birthday: "",
      },
      errors: [],
      isShowPassword: false,
    });

    const isAdmin = computed((): any => {
      return context.root.$store.state.currentUser.role == Common.RoleEnum.Admin || context.root.$store.state.currentUser.role == Common.RoleEnum.Teacher1;
    });

    // 登録ボタン押下
    const entryClick = async () => {

      if(!validate() || !window.confirm("教師情報を更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/user_edit/update/${context.root.$store.state.currentUser.id}`, {teacher: state.teacher}).then(response => {
        alert("教師情報の変更が完了しました。");
        context.root.$store.dispatch('goSheetList');
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    // バリデーション
    const validate = () => {
      state.errors = [];

      var regex = new RegExp(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i);
      if (!regex.test(state.teacher.password)) {
        state.errors.push("パスワードのフォーマットを確認してください。");
      }
      
      if (state.teacher.password != state.teacher.password_confirmation) {
        state.errors.push("パスワードが一致しません。");
      }

      return state.errors.length == 0;
    }

    const password_show = () => {
      if (state.isShowPassword) {
        (document.getElementById('password_check') as any).type = "password";
        (document.getElementById('password_confirmation_check') as any).type = "password";
        state.isShowPassword = false;
      } else {
        (document.getElementById('password_check') as any).type = "text";
        (document.getElementById('password_confirmation_check') as any).type = "text";
        state.isShowPassword = true;
      }
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      // ユーザー情報をapiから取得
      await http.get(`/api/teacher/user_edit?id=${context.root.$store.state.currentUser.id}`).then(response => {
        var teacher = response.data.teacher;
        state.teacher.login_id = teacher.login_id;
        state.teacher.name = teacher.name;
        state.teacher.curriculum_id = teacher.curriculum_id;
        state.teacher.curriculum_ids = teacher.curriculum_id.split(",");
        state.teacher.birthday = Common.formatDate(teacher.birthday, 'YYYY-MM-DD');
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`ユーザー情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`ユーザー情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      if (context.root.$store.state.currentUser.login_count == 1) {
        alert(`${state.teacher.name}先生、ありがとうございます。パスワードを登録してください`);
      }
    })

    return {
      ...toRefs(state),
      isAdmin,
      entryClick,
      validate,
      password_show,
    }
  }
})
